import { Box, TextField } from "@mui/material";
import { useTranslate } from "src/locales";
import Grid from "@mui/material/Grid";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzMuiCloseButton from "src/components/core-components/mui/buttons/ByzMuiCloseButton";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
type MealAddProps = {
    onClose: () => void; 
    selectedRow: number;
};
function MealAdd({ onClose, selectedRow }: MealAddProps) {
    const { t } = useTranslate();
   console.log(selectedRow); 
    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "7px 17px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <Box style={{ width: "100%" }}>
                    <Grid
                        container
                        sx={{ p: 2, borderBottom: "1px solid #E0E0E0", bgcolor: "#F4F7FE" }}
                    >
                        <ByzMuiTypography style={{ fontWeight: "bold" }}>
                            {t("ration.meal-add")}
                        </ByzMuiTypography>
                    </Grid>
                    <Box marginTop="10px" display="flex " justifyContent="space-between"  >
                        <ByzNurseSaveButton />
                        <ByzMuiCloseButton onClick={onClose} /> {/* Popup'ı kapatacak şekilde düzenlendi */}
                    </Box>
                </Box>
                <Box width="100%" >
                    <Grid
                        container
                        sx={{ margin: "8px", borderBottom: "1px solid #E0E0E0", marginBottom: "30px" }}
                    >
                    </Grid>
                </Box>
            </div>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "7px 17px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    height="100%"
                    marginTop="12px"
                    width={"100%"}
                    marginLeft="20px"
                >
                    <Grid container spacing={1}>
                        <Grid md={12} xs={12} container direction="row" spacing={5} alignItems="center"
                            justifyContent="space-between"
                            p={2}>
                            <Grid
                                md={7}
                                xs={7}
                                xl={7}
                                sx={{
                                    borderBottom: "1px solid #E0E0E0",
                                    fontWeight: "bold",
                                    textAlign: "bottom", // Yatayda ortalama
                                    lineHeight: "1.5rem", // Dikeyde daha iyi hizalama
                                    height: "100%",
                                    display: 'flex',
                                    backgroundColor: "#F4F7FE",
                                    p: 2
                                }} >
                                <ByzMuiTypography sx={{ textAlign: "center", marginLeft: "15px" }}>
                                    {t("ration.meal-add")}
                                </ByzMuiTypography>
                            </Grid>

                        </Grid>
                    </Grid>
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    height="100%"
                    marginTop="12px"
                    width={"100%"}
                    marginLeft="20px"
                >
                    <Grid container spacing={1}>
                        <Grid md={12} xs={12} container direction="row" spacing={5} alignItems="center"
                            justifyContent="space-between"
                            padding="15px">
                            <Grid
                                md={7}
                                xs={7}
                                xl={7}
                                style={{
                                    borderBottom: "1px solid #E0E0E0",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    lineHeight: "1.5rem",
                                    height: "100%",
                                    display: "flex",
                                }} >
                                <ByzMuiTypography style={{ textAlign: "center", marginLeft: "75px", justifyContent: "center", display: "flex", alignItems: "center" }}>
                                    {t("ration.office")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={5} xs={5}  >
                                <ByzMuiSelect renderInput={(params) => <TextField {...params} variant="outlined" />} options={[]} sx={{ width: '300px', marginLeft: '16px' }} color='info' label="Seçiniz" placeholder='Seçiniz' />
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    height="100%"
                    marginTop="12px"
                    width="100%"
                    marginLeft="20px"
                >
                    <Grid container spacing={1}>
                        <Grid md={12} xs={12} container direction="row" spacing={5} alignItems="center"
                            justifyContent="space-between"
                            padding="15px">
                            <Grid
                                md={7}
                                xs={7}
                                xl={7}
                                style={{
                                    borderBottom: "1px solid #E0E0E0",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    lineHeight: "1.5rem",
                                    height: "100%",
                                    display: "flex"
                                }} >
                                <ByzMuiTypography style={{ textAlign: "center", marginLeft: "75px", justifyContent: "center", display: "flex", alignItems: "center" }}>
                                    {t("ration.name")} <ByzMuiTypography style={{ color: "red" }}>*</ByzMuiTypography>
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={5} xs={5} >
                                <ByzMuiTextField style={{ width: "300px", marginLeft: "16px", marginTop: "10px" }} color="info" label="Adı" variant="outlined" />
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    height="100%"
                    marginTop="12px"
                    width="100%"
                    marginLeft="20px"
                >
                    <Grid container spacing={1}>
                        <Grid md={12} xs={12} container direction="row" spacing={5} alignItems="center"
                            justifyContent="space-between"
                            width="200%"
                            p={2}>
                            <Grid
                                md={7}
                                xs={7}
                                xl={7}
                                style={{
                                    borderBottom: "1px solid #E0E0E0",
                                    fontWeight: "bold",
                                    textAlign: "center", // Corrected from "bottom" to "center"
                                    lineHeight: "1.5rem",
                                    height: "100%",
                                    display: "flex"
                                }} >
                                <ByzMuiTypography style={{ textAlign: "center", marginLeft: "75px", justifyContent: "center", display: "flex", alignItems: "center" }}>
                                    {t("active")}?
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={5} xs={5} >
                                <ByzMuiCheckBox style={{ width: '35px', marginLeft: '5px', height: '50px' }} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    height="100%"
                    marginTop="12px"
                    width="100%"
                    marginLeft="20px"
                >
                    <Grid container spacing={1}>
                        <Grid md={12} xs={12} container direction="row" spacing={5} alignItems="center"
                            justifyContent="space-between"
                            width="200%"
                            padding="15px">
                            <Grid
                                md={7}
                                xs={7}
                                xl={7}
                                style={{
                                    borderBottom: "1px solid #E0E0E0",
                                    fontWeight: "bold",
                                    textAlign: "center", 
                                    lineHeight: "1.5rem",
                                    height: "100%",
                                    display: "flex"
                                }} >
                                <ByzMuiTypography style={{ textAlign: "center", marginLeft: "75px", justifyContent: "center", display: "flex", alignItems: "center" }}>
                                    {t("category")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={5} xs={5} >
                                <ByzMuiSelect renderInput={(params) => <TextField {...params} variant="outlined" />} options={[]} sx={{ width: '235px', marginLeft: '16px' }} color='info' label="Seçiniz" placeholder='Seçiniz' />
                            </Grid>
                        </Grid>

                    </Grid>
                </Box>
            </div>
        </>
    );
}
export default MealAdd;